export default () => {
    return [
        {
            path: '/movimenti/:propostaIdentifier',
            name: 'movimenti',
            component: () => import('./views/movimenti.vue'),
        },
    ];
};
